'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.constant('localStorageEnabled', (function() {
  // Safari, in Private Browsing Mode, does not support localStorage.
  // All calls to setItem throw QuotaExceededError.
  try {
    localStorage.setItem('localStorage', 1);
    localStorage.removeItem('localStorage');
    return true;
  } catch (e) {
    return false;
  }
})());
